import React from 'react';
import DsModal from './DsModal';
import AppDownloadBanner from './AppDownloadBanner';
import '../../css/common/AppDownloadBanner.css';

const AppDownloadNoticeModal = ({ open, onClose }) => (
  <DsModal
    open={open}
    onClose={onClose}
    title="アプリ版を公開しました"
    size="lg"
    className="app-download-notice-modal"
  >
    <AppDownloadBanner className="app-download-banner--modal" showTitle={false} />
  </DsModal>
);

export default AppDownloadNoticeModal;
